export const holidays = {
  MD: {
    // Month, Day
    '01/01': 'Confraternização Universal',
    // '04/07': 'Paixão de Cristo',
    '04/21': 'Tiradentes',
    '05/01': 'Dia do Trabalho',
    '09/07': 'Independência do Brasil',
    '10/12': 'Nossa Senhora Aparecida',
    '11/02': 'Finados',
    '11/15': 'Proclamação da República',
    '12/25': 'Natal'
  }
}

export const getFirstUtilDay = date => {
  if (!date) return date
  const weekDay = date.weekday()
  if (weekDay === 0) {
    date.add(1, 'day')
  } else if (weekDay === 6) {
    date.add(2, 'day')
  }
  if (holidays.MD[date.format('MM/DD')]) {
    date.add(1, 'day')
  }
  return date
}

export const parseTypeName = type => {
  const typeNames = {
    cash: 'Dinheiro',
    debit_card: 'Débito',
    card: 'Crédito',
    check: 'Cheque',
    pix: 'Pix',
    bank_slip: 'Boleto',
    debit: 'Débito automático',
    default: type
  }

  return typeNames[type] ?? typeNames.default
}

export const getBillItemNetValue = (bill, billItem) => {
  const total = getTotal(bill)
  const netValueTotal = getTotalWithTax(bill)
  const diff = total - netValueTotal
  if (diff <= 0) return billItem.final_value
  const netValue = billItem.final_value - (diff * billItem.final_value) / total
  return parseFloat(Math.round(netValue * 100) / 100)
}

const getTotalWithTax = bill => {
  if (!bill.payments) {
    return 0
  }
  const total = bill.payments.reduce((acc, payment) => {
    acc += payment.installments.reduce((acc, installment) => {
      acc += installment.amount
      return acc
    }, 0)
    return acc
  }, 0)
  return total
}

const getTotal = bill => {
  if (!bill.payments) {
    return 0
  }
  const total = bill.payments.reduce((acc, payment) => {
    acc += payment.amount
    return acc
  }, 0)
  return total
}

export const automaticReconciliationStatus = {
  RECONCILED: 'reconciled',
  MATCHED_AUTO: 'matched_auto',
  /** Pareamento sugerido pela API (parcial); só entra em Revisão após confirmação do usuário. */
  MATCHED_SYSTEM_PARTIAL: 'matched_system_partial',
  /** Pareamento confirmado pelo usuário (aceite da sugestão ou pesquisa + Parear). */
  MATCHED: 'matched',
  UNMATCHED_IMPORTED: 'unmatched_imported',
  UNMATCHED_SYSTEM: 'unmatched_system',
  ALREADY_RECONCILED: 'already_reconciled'
}

/**
 * Status da LINHA DO EXTRATO (bank_reconciliation_entries.status), derivado no
 * backend a partir das parcelas conciliadas (ver ReconciliationRepository::recomputeEntryStatus).
 * 'partial' = há parcela(s) conciliada(s) porém a soma ainda não fecha com o
 * valor do lançamento — antes esse caso aparecia como 'pending' e divergia do
 * financeiro (card 86ajeywqw).
 */
export const reconciliationEntryStatus = {
  PENDING: 'pending',
  PARTIAL: 'partial',
  RECONCILED: 'reconciled',
  ARCHIVED: 'archived'
}

/** Rótulo + classes de badge para o status da linha do extrato. */
export const reconciliationEntryStatusBadge = status => {
  switch (status) {
    case reconciliationEntryStatus.RECONCILED:
      return { text: 'Conciliado', class: 'bg-green-100 text-green-500' }
    case reconciliationEntryStatus.PARTIAL:
      return {
        text: 'Parcialmente conciliado',
        class: 'bg-amber-100 text-amber-700'
      }
    case reconciliationEntryStatus.ARCHIVED:
      return { text: 'Arquivado', class: 'bg-neutral-100 text-neutral-600' }
    default:
      return { text: 'Pendente', class: 'bg-amber-100 text-amber-700' }
  }
}

export const parseBillStatusName = status => {
  switch (status) {
    case 'paid_out':
      return 'Pago'
    case 'pending':
      return 'Pendente'
    case 'expired':
      return 'Expirado'
    case 'partial_paid_out':
      return 'Parc. pago'
    case 'disallowed':
      return 'Glosado'
    case 'on_appeal':
      return 'Em recurso'
    case 'Em elaboração':
      return 'Em elaboração'
    case 'Aguardando autorização':
      return 'Aguardando autorização'
    case 'Autorizada':
      return 'Autorizada'
    case 'Negada':
      return 'Negada'
    case 'Cancelada':
      return 'Cancelada'
    case 'Enviado':
      return 'Enviado'
    case 'Em aberto':
      return 'Em aberto'
    case 'Pago':
      return 'Pago'
    case 'Pago parcialmente':
      return 'Pago parcialmente'
    case 'Glosado':
      return 'Glosado'
    default:
      return status
  }
}
/**
 * Formata o nome de um método de pagamento incluindo a bandeira do cartão quando disponível
 * @param {Object} paymentMethod - Método de pagamento com propriedades name, type, card_flag
 * @param {boolean} includeType - Se true, inclui o tipo do método no formato (ex.: "Crédito", "Débito")
 * @returns {string} Nome formatado do método de pagamento com bandeira (se aplicável)
 */
export const formatPaymentMethodName = (paymentMethod, includeType = false) => {
  if (!paymentMethod) return '-'

  let displayName = paymentMethod.name || '-'
  // Adiciona a bandeira do cartão quando disponível (para crédito e débito)
  if (
    paymentMethod.card_flag &&
    (paymentMethod.type === 'card' || paymentMethod.type === 'debit_card')
  ) {
    displayName = `${displayName} (${paymentMethod.card_flag.name})`
  }

  if (includeType) {
    const typeName = parseTypeName(paymentMethod.type)
    return `${displayName} (${typeName})`
  }

  return displayName
}

/**
 * Formata uma lista de métodos de pagamento para exibição em tabelas
 * @param {Object} bill - Conta com propriedades payments e category
 * @returns {string} String formatada com os métodos de pagamento
 */
export const getPaymentMethodDisplay = bill => {
  if (!bill?.payments || !bill.payments.length) {
    return '-'
  }

  const methods = bill.payments
    .map(payment => payment.payment_method)
    .filter(Boolean)

  if (!methods.length) {
    return '-'
  }

  // Para transferências, exibimos um rótulo baseado no "type",
  // evitando mostrar nomes muito específicos (ex.: que carregam a conta).
  if (bill?.category?.name === 'Transferência') {
    const typeMap = {
      cash: 'Dinheiro',
      pix: 'Pix',
      debit_card: 'Cartão de Débito',
      card: 'Cartão de Crédito',
      bank_slip: 'Boleto',
      check: 'Cheque'
    }

    const methodLabel = methods
      .map(method => typeMap[method.type] || method.name || '-')
      .filter(Boolean)
      .join(', ')

    let accountLabel = ''
    const description = bill.description || ''

    const destinoIndex = description.toLowerCase().indexOf('destino:')
    const origemIndex = description.toLowerCase().indexOf('origem:')

    if (destinoIndex !== -1) {
      accountLabel = description
        .slice(destinoIndex + 'destino:'.length)
        .split('.')[0]
        .trim()
    } else if (origemIndex !== -1) {
      accountLabel = description
        .slice(origemIndex + 'origem:'.length)
        .split('.')[0]
        .trim()
    }

    if (accountLabel) {
      return `${methodLabel} - ${accountLabel}`
    }

    return methodLabel
  }

  return methods
    .map(method => formatPaymentMethodName(method))
    .filter(Boolean)
    .join(', ')
}

/**
 * Formata uma lista de métodos de pagamento para uso em Autocompletes/Filtros
 * @param {Array} paymentMethods - Array de métodos de pagamento da API
 * @returns {Array} Array formatado com label e value para uso em componentes de seleção
 */
export const formatPaymentMethodsForAutocomplete = paymentMethods => {
  if (!paymentMethods || !Array.isArray(paymentMethods)) {
    return []
  }

  return paymentMethods.map(paymentMethod => {
    let label = paymentMethod.name || ''
    // Adiciona a bandeira do cartão quando disponível (para crédito e débito)
    if (
      paymentMethod.card_flag &&
      (paymentMethod.type === 'card' || paymentMethod.type === 'debit_card')
    ) {
      label = `${paymentMethod.name} (${paymentMethod.card_flag.name})`
    }
    return { ...paymentMethod, label, value: `${paymentMethod.id}` }
  })
}

export const getFilterLabel = label => {
  const labels = {
    is_reconciled: 'Status da Conciliação',
    status_payment: 'Situação de Pagamento',
    description: 'Descrição',
    period_status: 'Período',
    period_order: 'Ordenação do período',
    period: 'Período',
    type: 'Entrada/Saída',
    query: 'Descrição',
    start: 'Início',
    end: 'Fim',
    bank_account: 'Conta Bancária',
    payment_method: 'Meio de Pagamento',
    nsu: 'NSU / Descrição do Pagamento',
    amount: 'Valor',
    reconciled_by: 'Concilado por',
    beneficiary: 'Favorecido',
    patient: 'Paciente',
    cost_center: 'Centro de Custo'
  }

  return labels[label] || label
}

// ─── conciliação: linhas puladas pela trava de valor ──────────────────────────
//
// Card 86ajyhpd6. A trava do backend concilia as linhas do extrato que fecham e
// devolve em `skipped` as que ficariam com soma das parcelas != valor da linha
// (antes ela abortava o lote inteiro). Estes helpers formatam esse retorno para o
// usuário e remontam o payload de reenvio quando ele confirma a conciliação parcial.

const formatBRL = value =>
  (Number(value) || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

export const reconciliationSkippedTransactions = (skipped = []) =>
  (Array.isArray(skipped) ? skipped : []).flatMap(line =>
    Array.isArray(line?.transactions) ? line.transactions : []
  )

/** fit_id da linha do extrato (uniqueId quando o OFX não traz fit_id). */
const importedFitId = item =>
  item?.imported_transaction?.fit_id ??
  item?.imported_transaction?.uniqueId ??
  null

/**
 * Desfaz o feedback otimista SÓ nas linhas de `fitIds`, trazendo-as de volta do
 * snapshot anterior à conciliação. O resultado do backend é parcial (concilia o
 * que fecha, pula o resto), então o desfazer também precisa ser: reverter o
 * importedOFX inteiro apagaria da tela as linhas que conciliaram de fato.
 */
export const rollbackImportedOFXLines = (current, snapshot, fitIds = []) => {
  const targets = (Array.isArray(fitIds) ? fitIds : []).filter(Boolean)
  if (!targets.length) return current
  if (!Array.isArray(current?.data) || !Array.isArray(snapshot?.data)) {
    // Sem as duas listas não há como mesclar por linha; o snapshot inteiro é o
    // estado mais seguro (nunca mostra como conciliado o que não foi).
    return snapshot ?? current
  }

  const previousByFitId = new Map(
    snapshot.data.map(item => [importedFitId(item), item]).filter(([id]) => id)
  )

  return {
    ...current,
    data: current.data.map(item => {
      const fitId = importedFitId(item)
      if (!fitId || !targets.includes(fitId)) return item
      return previousByFitId.get(fitId) ?? item
    })
  }
}

export const formatReconciliationSkippedLines = (skipped = [], limit = 5) => {
  const lines = Array.isArray(skipped) ? skipped : []
  if (!lines.length) return ''

  const shown = lines
    .slice(0, limit)
    .map(
      line =>
        `${line?.fit_id || 'linha sem identificador'} — extrato ${formatBRL(
          line?.entry_amount
        )}, lançamentos ${formatBRL(line?.projected_sum)}`
    )

  const rest = lines.length - shown.length
  if (rest <= 0) return shown.join('; ')

  return `${shown.join('; ')}; e mais ${rest} ${
    rest === 1 ? 'linha' : 'linhas'
  }`
}
